/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-03 17:24:02
 * @LastEditors: JikeyChang
 * @LastEditTime: 2022-08-14 16:39:10
 * @Description: 人员管理、组织管理需要放在vuex的数据模块中
 */
import db from '@/api/feishu/changeRecord.js'; // 对应api-js路径

export default {
  namespaced: true,
  state: {
    changeRecordMsg: {},
  },
  actions: {
    // 获取变更记录
    getChangeRecordMsg({ commit }, param) {
      return db.getChangeRecord(param).then((result) => {
        commit('setChangeRecordMsg', result.page);
      }).catch(e => e);
    },
  },
  mutations: {
    setChangeRecordMsg(state, content) {
      state.changeRecordMsg = content;
    },
  },
};
